import React, { useState } from 'react'
import { opcionesSideBar, ROL_ADMINISTRADOR, ROL_ANALISTA_TH, ROL_DIRECTIVO_UNIDAD, ROL_CONSULTOR, useSideBarContext } from 'Context/SideBarContext'
import Sidebar_Principal_Row from './Sidebar_Principal_Row';
import { TransitionStatus } from 'react-transition-group';
import { UserData } from './Sidebar_Principal';

export interface Sidebar_Principal_ContentProps {
    state_transition: TransitionStatus,
    datos_usuario: UserData

}

export function function_renderizado_segun_rol_usuarios(opciones: opcionesSideBar, index: number, roles_usuario: Array<string>, devuelve: string, planificarVacaciones:boolean) {

    var resultado: JSX.Element = <React.Fragment></React.Fragment>;
    
    // const auxiliar_validar_planificacion_vacaciones = (opcion:opcionesSideBar,resultado:JSX.Element) =>{
    //     console.log(opcion.titulo)
        
    // }

    const opcion_barra = (
        <React.Fragment key={index}>
            {!opciones.tipo.rows ?
                <div className="sidenavPrincipalHeader"   >
                    <div className="container_icono_Principal_Content">
                        {opciones.icon()}
                    </div>
                    <div className=" texto_sidenavPrincipalHeader">
                        {opciones.titulo}

                    </div>
                </div> :
                <Sidebar_Principal_Row titulo_opcion_padre={opciones.titulo} subopciones={opciones} isChild={false} icon_opcion_padre={opciones.icon} />
            }

        </React.Fragment>
    )

    const opcion_icono = (
        <React.Fragment key={index + "iconoRolesDP"}>
            <div className="iconosMenuDatosPersonales ">
                {opciones.icon ? opciones.icon() : ""}
            </div>
        </React.Fragment>
    )

    if (devuelve === "ICONO") resultado = opcion_icono
    else if (devuelve === "COMPONENTE") resultado = opcion_barra

    //Si las opciones tienen un rol
    if (opciones.rol_usuario) {


        var indice_respuesta: number = roles_usuario.findIndex((value, index) => {
            return value == opciones.rol_usuario
        })

        if (indice_respuesta != -1) {
            return resultado
        }

        if(opciones.rol_usuario && opciones.rol_usuario === ROL_ADMINISTRADOR){
            if(roles_usuario.includes(ROL_ANALISTA_TH)){
                return resultado
            }
        }


    }
    else {
        return resultado
    }

}


const Sidebar_Principal_Content = (props: Sidebar_Principal_ContentProps) => {
    const { valoresMenuPrincipal } = useSideBarContext();
    const { roles_usuario,periodo_planificacion_vac_activo } = props.datos_usuario
    // const [ishover, setishover] = useState<boolean>(false)




    return (
        <div className="sidenavPrincipalContainer" style={props.state_transition === "exiting" ? { animation: "moveMainContainer .3s forwards" } :
            props.state_transition === "entering" ? { animation: "moveMainContainer .3s reverse backwards" } : {}} >
            {valoresMenuPrincipal && valoresMenuPrincipal.map((opciones, index) => {
                return function_renderizado_segun_rol_usuarios(opciones, index, roles_usuario, 'COMPONENTE',periodo_planificacion_vac_activo)
            })}
        </div>
    )
}

export default Sidebar_Principal_Content;
